/** Clearance kept between the menu and the panel edges, including the purchase actions. */
export const KITLOOK_SKU_MENU_BOUNDARY_GAP = 8

/** Cap carried over from the inline list so long size sets still scroll. */
export const KITLOOK_SKU_MENU_MAX_HEIGHT = 210

export interface KitlookSkuMenuTriggerRect {
  top: number
  bottom: number
  left: number
  width: number
}

export type KitlookSkuMenuPosition = {
  left: number
  width: number
  maxHeight: number
} & ({ placement: 'down'; top: number } | { placement: 'up'; bottom: number })

interface GetKitlookSkuMenuPositionParams {
  trigger: KitlookSkuMenuTriggerRect
  boundaryTop: number
  boundaryBottom: number
  viewportHeight: number
  viewportWidth: number
  contentHeight: number
}

export function getKitlookSkuMenuPosition({
  trigger,
  boundaryTop,
  boundaryBottom,
  viewportHeight,
  viewportWidth,
  contentHeight,
}: GetKitlookSkuMenuPositionParams): KitlookSkuMenuPosition {
  const topLimit = Math.max(0, boundaryTop)
  const bottomLimit = Math.min(viewportHeight, boundaryBottom)
  const spaceBelow = Math.max(
    0,
    bottomLimit - trigger.bottom - KITLOOK_SKU_MENU_BOUNDARY_GAP
  )

  const spaceAbove = Math.max(
    0,
    trigger.top - topLimit - KITLOOK_SKU_MENU_BOUNDARY_GAP
  )

  const neededHeight = Math.min(
    KITLOOK_SKU_MENU_MAX_HEIGHT,
    contentHeight > 0 ? contentHeight : KITLOOK_SKU_MENU_MAX_HEIGHT
  )

  const placement =
    spaceBelow >= neededHeight || spaceBelow >= spaceAbove ? 'down' : 'up'

  const availableSpace = placement === 'down' ? spaceBelow : spaceAbove
  const maxHeight = Math.max(0, Math.min(neededHeight, availableSpace))
  const width = trigger.width + 2
  const maxLeft = Math.max(0, viewportWidth - width)
  const left = Math.min(Math.max(0, trigger.left - 1), maxLeft)

  if (placement === 'down') {
    return {
      placement,
      top: trigger.bottom,
      left,
      width,
      maxHeight,
    }
  }

  return {
    placement,
    bottom: viewportHeight - trigger.top,
    left,
    width,
    maxHeight,
  }
}
